<template>
  <div v-show="Display" class="playlist-detail-page">
    <!-- Top Bar -->
    <div class="top-bar">
      <button class="back-button" @click="close">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7"/>
        </svg>
      </button>
      <div class="playlist-header">
        <h1 class="playlist-title">{{ playlist.name }}</h1>
        <p class="playlist-info">{{ playlist.audios.length }} audio{{ audios.length !== 1 ? 's' : '' }}</p>
      </div>
      <button class="menu-button" @click="toggleMenu">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="1"/>
          <circle cx="12" cy="5" r="1"/>
          <circle cx="12" cy="19" r="1"/>
        </svg>
      </button>
    </div>

    <!-- Options Menu -->
    <div class="menu-overlay" v-if="showMenu" @click="toggleMenu">
      <div class="menu-dropdown" @click.stop>
        <button class="menu-option" @click="clearPlaylist">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="3 6 5 6 21 6"/>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
          </svg>
          Clear All
        </button>
        <button class="menu-option danger" @click="deletePlaylist">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="3 6 5 6 21 6"/>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/>
          </svg>
          Delete Playlist
        </button>
      </div>
    </div>

    <!-- Audio List -->
    <div class="audio-list">
      <div 
        v-for="(audio, index) in playlist.audios" 
        :key="audio.id || index"
        class="audio-item-wrapper1"
      >
        <!-- Audio Card Component -->
        <AudioCard
          @click=" this.$root.$refs.audioPlayers.show(
            playlist.audios,
            index,
            playlist.name 
          )" 
          :audio="audio"
          :editButtonEnable="false"
          ref="audioCards"
          @playingEnded="playNext(index)"
        />
        
        <!-- Small delete button overlay -->
        <button 
          class="delete-audio-btn" 
          @click="deleteAudio(index)"
          title="Remove from playlist"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>

      <!-- Empty State -->
      <div class="empty-state" v-if="playlist.audios.length === 0 && !loading">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M9 18V5l12-2v13"/>
          <circle cx="6" cy="18" r="3"/>
          <circle cx="18" cy="16" r="3"/>
        </svg>
        <p>No audios in this playlist</p>
        <span class="empty-hint">Add audios from your library</span>
      </div>
    </div>

  </div>
</template>

<script>
import AudioCard from '@/views/components/audioCard/AudioCard.vue'

export default {
  name: 'PlaylistDetail',
  components: {
    AudioCard
  },
  data() {
    return {
      Display:false,
      playlist:{audios:[]},
      audios: [],
      loading: false,
      showMenu: false,
      audioToDelete: null,
      audioIndexToDelete: null,
      // Mock data for standalone testing
      useMockData: false
    }
  },
  methods: {
    close() {
      this.Display = false
    },
    async show(pl) {
      this.playlist =  JSON.parse(JSON.stringify(pl))
      this.Display = true

      // save images to cache if not already saved
      let i=0, max = this.playlist.audios.length
      if(max === 0) return // no audio to cache images or update
      for(i=0;i<max;i++) {
        await this.cachePublicationImage(this.playlist.audios[i])
      } 

      // lauch publication updating
      this.updatePublications()
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    playNext(index) {
      if (index + 1 >= this.playlist.audios.length) return;
      this.$refs.audioCards[index + 1].togglePlay();
    },
    deleteAudio(index) {
      if (!this.playlist.audios[index]) return
      this.playlist.audios.splice(index, 1);
      this.$emit('playlistChanged',this.playlist)
    },
    clearPlaylist() {
      this.playlist.audios = []
      this.$emit('playlistChanged',this.playlist)
      this.showMenu = false;
    },
    deletePlaylist() {
      this.$emit('deleteMe',this.playlist)
      this.showMenu = false;
      this.Display = false
    },
    async updatePublications () {
      try {
        const pubIds = []
        const usersToGet = new Set()
        const audios = this.playlist.audios
        audios.forEach(aud => {
          pubIds.push(aud._id)
          usersToGet.add(aud.userId)
        });
        const res  = await this.$axios.post('publication.php', { type: 'getPublicationByIds', pubs: pubIds })
        //console.log(res.data)
        //--- updating Playlist -------------
        const max = audios.length
        const updatedMap = new Map(res.data.map(item => [item._id, item]))
        for (let i = 0; i < max; i++) {
          const audio = updatedMap.get(audios[i]._id)
          if(audio) audios[i] = audio
        }
        this.$store.commit('updatePlayList',this.playlist)
        // get user metadata
        const k = this
        if(usersToGet.size > 0) {
          const res2 = await this.$axios.post('user.php',{type:"getUsersMetaData",users:[...usersToGet]})
          const users = res2.data || []
          users.forEach(us => {
            k.$store.commit('setAnUser',us)
          })
        }
      } catch (e) {
        console.error(e?.response ?? e)
      }
    },
    async cachePublicationImage(pub) {
      if (!('caches' in window)) return
      const cache   = await caches.open('audio-cache-v1')
      const baseUrl = this.$store.state.baseUrl + 'images/'

      const userProfile = this.$store.state.users[pub.userId] || {}
      const urls = [
        pub.img     ? baseUrl + pub.img     : null,
        pub.imgMini ? baseUrl + pub.imgMini : null,
        userProfile.profilImgMini1 ? baseUrl + userProfile.profilImgMini1 : null
      ].filter(Boolean)

      await Promise.all(urls.map(async (url) => {
        try {
          const already = await cache.match(url)
          if (already) return
          const response = await fetch(url)
          if (response.ok) await cache.put(url, response)
        } catch (e) {
          console.warn('Image cache failed for', url, e)
        }
      }))
    },
  }
}
</script>

<style scoped>
.playlist-detail-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #0a0e26;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  overflow-y: auto;
  z-index: 100;
}

.top-bar {
  position: sticky;
  top: 0;
  background: rgba(10, 14, 38, 0.95);
  border-bottom: 1px solid rgba(0, 212, 255, 0.1);
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 100;
}

.back-button {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  color: #e0f7ff;
  transition: all 0.2s;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.back-button svg {
  width: 24px;
  height: 24px;
}

.back-button:hover {
  background: rgba(0, 212, 255, 0.1);
  color: #00d4ff;
}

.playlist-header {
  flex: 1;
  text-align: center;
  margin: 0 16px;
  min-width: 0;
}

.playlist-title {
  color: #e0f7ff;
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 4px 0;
  text-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.playlist-info {
  color: #94a3b8;
  font-size: 12px;
  margin: 0;
}

.menu-button {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  color: #e0f7ff;
  transition: all 0.2s;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.menu-button svg {
  width: 24px;
  height: 24px;
}

.menu-button:hover {
  background: rgba(0, 212, 255, 0.1);
  color: #00d4ff;
}

/* Menu Dropdown */
.menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 200;
}

.menu-dropdown {
  position: absolute;
  top: 60px;
  right: 20px;
  background: rgba(10, 14, 38, 0.98);
  border: 1px solid rgba(0, 212, 255, 0.2);
  border-radius: 12px;
  padding: 8px;
  min-width: 180px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}

.menu-option {
  width: 100%;
  background: transparent;
  border: none;
  padding: 12px 16px;
  color: #e0f7ff;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 8px;
  transition: all 0.2s;
  text-align: left;
}

.menu-option svg {
  width: 18px;
  height: 18px;
  margin-right: 12px;
  flex-shrink: 0;
}

.menu-option:hover {
  background: rgba(0, 212, 255, 0.1);
}

.menu-option.danger {
  color: #ff3b30;
}

.menu-option.danger:hover {
  background: rgba(255, 59, 48, 0.1);
}

/* Audio List */
.audio-list {
  padding: 16px;
  padding-bottom: 100px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}

.audio-item-wrapper1 {
  display: flex;
  width: 25%;
  max-width: 200px;
  position: relative;
}
.audio-item-wrapper1 > .audio-card {
  width: 100%;
  max-width:none;
  aspect-ratio:unset;
}


.delete-audio-btn {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 24px;
  height: 24px;
  background: rgba(10, 14, 38, 0.1);
  border: none;
  border-radius: 50%;
  color: #ff3b30;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  z-index: 10;
  padding: 0;
}


.delete-audio-btn svg {
  max-width: 16px;
  max-height: 16px;
  stroke-width: 1.5;
  pointer-events: none;
}


.delete-audio-btn:hover {
  background: rgba(255, 59, 48, 0.3);
  border-color: #ff3b30;
  transform: scale(1.15);
}

.delete-audio-btn:active {
  transform: scale(0.95);
}

/* Empty State */
.empty-state {
  width: 100%;
  text-align: center;
  padding: 80px 20px;
  color: #94a3b8;
}

.empty-state svg {
  width: 80px;
  height: 80px;
  color: rgba(0, 212, 255, 0.3);
  margin-bottom: 20px;
}

.empty-state p {
  font-size: 16px;
  margin: 0 0 8px 0;
  color: #e0f7ff;
}

.empty-hint {
  font-size: 12px;
  color: #94a3b8;
}

/* Loading State */
.loader {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
}

.loader img {
  width: 60px;
  height: 60px;
}



/* Medium screens */
@media (max-width: 1024px) {
  .audio-item-wrapper1  {
    width: 25%;
  }
}

@media (max-width: 768px) {

  .audio-item-wrapper1 {
    width: 33.33%;
  }
}

/* Small screens */
@media (max-width: 350px) {
  .audio-item-wrapper1 {
    width: 50%;
  }
}
</style>